@use "../../sass/variables/colors";
@use "../../sass/variables/z-index";

:host {
  height: 0;
  overflow: visible;
  width: 0;
}
// switched to here as display for tooltip was overwritten in _pre-hydration file
:host(.hydrated) {
  display: block;
}

.box {
  background-color: colors.$color-white;
  box-shadow: var(--ux-tooltip-box-shadow);
  height: auto;
  overflow: visible;
  padding: var(--ux-tooltip-padding);
  position: fixed;
  text-align: left;
  visibility: hidden;
  width: var(--ux-tooltip-width, 300px);
  max-width: var(--ux-tooltip-max-width);
  z-index: z-index.$z-index-tooltip;
  top: var(--ux-tooltip-box-top, auto);
  left: var(--ux-tooltip-box-left, auto);
  border: var(--ux-tooltip-border, none);

  &--active {
    visibility: inherit;
  }
}

.box > * {
  padding-right: 20px;
}

.tip {
  position: absolute;
  left: var(--ux-tooltip-custom-tip-position, 50%);
  top: 100%;

  // ::before is used to create the black border on the tip (only used for responsive theme)
  &::before {
    border-color: var(--ux-tooltip-border-color) transparent transparent;
    border-style: solid;
    border-width: var(--ux-tooltip-tip-size);
    transform: translate(0, 1px);
    content: var(--ux-tooltip-tip-border-content, none);
    margin-left: var(--ux-tooltip-tip-margin-left);
    position: absolute;
    z-index: 1;
  }

  // ::after is used to create the tip itself
  &::after {
    border-color: colors.$color-white transparent transparent;
    border-style: solid;
    border-width: var(--ux-tooltip-tip-size);
    content: "";
    margin-left: var(--ux-tooltip-tip-margin-left);
    position: absolute;
    z-index: 1;
  }

  &-shadow {
    box-shadow: var(--ux-tooltip-tip-shadow);
    height: 15px;
    position: absolute;
    width: 2px;
    z-index: -1;
  }
}

.box--right {
  transform: translateY(-50%);

  .tip {
    top: 50%;
    left: -30px;

    &::after {
      border-color: transparent colors.$color-white transparent transparent;
      transform: translate(50%, -50%);
    }

    &-shadow {
      box-shadow: -10px 5px 15px 0.6px rgba(0, 0, 0, 0.3);
      height: 2px;
      left: 10px;
      transform: translate(50%, -50%);
      width: 15px;
    }
  }
}

.box--left {
  transform: translate(-100%, -50%);

  .tip {
    left: 100%;
    top: 50%;

    &::after {
      border-color: transparent transparent transparent colors.$color-white;
      transform: translate(50%, -50%);
    }

    &-shadow {
      box-shadow: 5px 5px 15px 0.6px rgba(0, 0, 0, 0.3);
      height: 2px;
      width: 15px;
    }
  }
}

.box--top {
  transform: translate(-50%, -100%);

  .tip {
    bottom: 0;
  }
}

.box--bottom {
  transform: translateX(-50%);

  .tip {
    top: -30px;

    &::after {
      border-color: transparent transparent colors.$color-white transparent;
    }

    &-shadow {
      box-shadow: 0 -10px 15px 0.6px rgba(0, 0, 0, 0.3);
      top: 20px;
    }
  }
}

.box--top-edge .tip {
  bottom: 0%;
  transform: translate(0px, -1px);

  &::before {
    border-width: 0 0 11px 11px;
    border-color: transparent transparent transparent var(--ux-tooltip-border-color);
    transform: translate(-1px, 2px);
  }

  &::after {
    border-width: 0 0 11px 11px;
    border-color: transparent transparent transparent colors.$color-white;
  }

  &-shadow {
    display: none;
  }

  &.tip--right {
    &::before {
      border-width: 0 11px 11px 0;
      border-color: transparent var(--ux-tooltip-border-color) transparent transparent;
    }

    &::after {
      border-width: 0 11px 11px 0;
      border-color: transparent colors.$color-white transparent transparent;
      transform: translate(-2px, 0);
    }
  }
}

.box--bottom-edge .tip {
  top: -10px;

  &::before {
    border-width: 11px 0 0 11px;
    border-color: transparent transparent transparent var(--ux-tooltip-border-color);
    transform: translate(-1px, -2px);
  }

  &::after {
    border-width: 11px 0 0 11px;
    border-color: transparent transparent transparent colors.$color-white;
  }

  &-shadow {
    display: none;
  }

  &.tip--right {
    &::before {
      border-width: 11px 11px 0 0;
      border-color: transparent var(--ux-tooltip-border-color) transparent transparent;
    }

    &::after {
      border-width: 11px 11px 0 0;
      border-color: transparent colors.$color-white transparent transparent;
      transform: translate(-2px, 0px);
    }
  }
}

.box--tip-right {
  transform: translateX(-100%);
}

.tip--right {
  right: -11px;
  left: auto;
}

.wrapper {
  max-height: var(--ux-tooltip-max-height, none);
  overflow-y: var(--ux-tooltip-overflow-y, visible);
}

.wrapper--text-only-mode {
  color: var(--ux-tooltip-text-color);
  font-size: var(--ux-tooltip-font-size);
  line-height: var(--ux-tooltip-line-height);
  font-family: var(--ux-font);
  margin-bottom: 0px;
  margin-top: 0px;
}
